import Vue from "vue"
import Vuetify from "vuetify/lib"
import "vuetify/src/stylus/app.styl"
import "@/assets/icon/style.css"
import "@fortawesome/fontawesome-free/css/all.css"

const settings = {
  options: {
    customProperties: true
  },
  iconfont: "md",
  theme: {
    primary: "#76A882",
    secondary: "#43425D",
    accent: "#76A882",
    info: "#51BEA2",
    // success: "#51BEA2",
    rec: "#FF9191",
    stop: "#206076",
    report: "#206076",
    progress: "#FF9C00",
    cancel: "#707070",
    unavailable: "#EAE8E8",
    background: "#F3F6F7",
    basetext: "#707070",
    btntext: "#3d3d3d",
    danger: "#ff0206",
  }
}
Vue.use(Vuetify, settings)

export default settings
